/** Charge la base de données de la maquette (toutes les collections) depuis l'API Java, une fois connecté. */
export default defineNuxtPlugin(async () => {
  const user = useCurrentUser()
  if (!user.value) await fetchMe()
  if (useCurrentUser().value) await loadDb()
})
